module.exports = __webpack_public_path__ + "img/spiner.cac6f4f6.gif";